import { Box, Typography } from "@mui/material";
import { FullWidthSection } from "../../../ReusableComponents/FullWidthSection";
import { TaxonomyPath } from "../../../ReusableComponents/TaxonomyPath";
import { SPACING } from "../../../../utils/constants/designConstants";
import theme from "../../../../theme";
import { SuppliersToShowTable } from "./Suppliers";
import { ExistingSuppliersTable } from "./ExistingSuppliers";

export const SuppliersSection = ({
  sectionRefs,
  taxonomyPath,
  suppliersToShow,
  existingSuppliers,
}) => {
  return (
    <FullWidthSection
      backgroundColor="primary.main"
      borderRadiusTopRight={theme.borderRadius.full}
    >
      <Box
        id="suppliers"
        component="section"
        aria-label="suppliers"
        className="generate-insights-content-inside-box"
        // ref={(el) => (sectionRefs.current["suppliers"] = el)}

        sx={{
          display: "flex",
          flexDirection: "column",
          color: "primary.white",
        }}
      >
        <Box sx={{ mb: SPACING.HEADING_BOTTOM, mt: SPACING.HEADING_TOP }}>
          <Typography variant="h1" component="h1">
            Suppliers
          </Typography>

          {/* Show taxonomy path */}
          <TaxonomyPath taxonomyPath={taxonomyPath} />
        </Box>
        <Box
          sx={{
            gap: SPACING.SECTION_GAP,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Suppliers to Show */}
          <SuppliersToShowTable suppliersToShow={suppliersToShow} />

          {/* Existing Suppliers */}
          <Box>
            <Typography
              variant="h2"
              component="h2"
              sx={{ mb: SPACING.SUBHEADING_BOTTOM }}
            >
              Existing Suppliers Table
            </Typography>

            <ExistingSuppliersTable existingSuppliers={existingSuppliers} />
          </Box>
        </Box>
      </Box>
    </FullWidthSection>
  );
};
